import React from 'react';
import { WeaAlertPage, WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export default () => (
    <WeaAlertPage >
        <div style={{ color: '#000' }}>
            {getLabel(2012,'对不起，您暂时没有权限！')}
        </div>
    </WeaAlertPage>
)


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/no-right/index.tsx